import React from 'react'
import "./Layout.scss"
import Header from './Header'
import Footer from './Footer'
import {Outlet} from "react-router-dom"
import ScrollToTop from "../Other/ScrollToTop"

const Layout = () => {
  return (
    <div className="container">
      <Header />
      <div className="main-content">
            <ScrollToTop />
        <Outlet />
      </div>
      <Footer />
    </div>
  )
}

export default Layout